import { Steps } from 'antd';

/** Paso del flujo de Pantallas Digitales. */
export type DoohFlowStep = 'media' | 'broadcast' | 'screens';

const FLOW_STEPS: { key: DoohFlowStep; title: string; description: string }[] = [
  { key: 'media', title: 'Biblioteca de medios', description: 'Sube imágenes y videos.' },
  { key: 'broadcast', title: 'Emisión global', description: 'Crea la playlist.' },
  { key: 'screens', title: 'Pantallas', description: 'Revisa el estado de las pantallas.' },
];

/**
 * Pista del flujo operativo de Pantallas Digitales
 * (**biblioteca de medios → emisión global → pantallas**), para orientar al
 * operador sobre dónde está y qué sigue. No es navegable: solo marca el paso
 * actual. Compartida por las tres páginas de `features/dooh`.
 */
export function DoohFlowHint({ current }: { current: DoohFlowStep }) {
  const currentIndex = FLOW_STEPS.findIndex((step) => step.key === current);

  return (
    <Steps
      className="dooh-flow"
      size="small"
      labelPlacement="horizontal"
      current={currentIndex}
      items={FLOW_STEPS.map(({ title, description }) => ({ title, description }))}
    />
  );
}
